import { AbstractControl, ValidatorFn } from '@angular/forms';

export function autocompleteValidator(Services: any[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const indexx = Services.indexOf(control.value);
    // const index = Services.findIndex(Service => {
    //   console.log(control.value)
    //   console.log(Service)
    //   console.log(control.value == Service)
    //   return new RegExp("^" + Service + "$").test(control.value);
    // });
    return indexx < 0 ? { forbiddenNames: { value: control.value } } : null;
  };
}